/**
 *
 * Asynchronously loads the component for SignupSuccess
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
